export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/0c7f90dcab4574f291a5b93f31621815.svg";